// Livello comune di musica ed effetti. Ogni suono riceve un piccolo guadagno (solo attenuazione) che porta
// il suo momento più forte al livello di LOUDNESS_TARGET_LUFS, così tutti i file suonano allo stesso volume
// senza ricodificarli (nessuna perdita di qualità e il loop della BGM resta intatto).
//
// Si equalizza il picco di loudness momentanea (finestra di 400 ms, EBU R128) e non la media integrata:
// la BGM è costante (quasi tutta vicina al suo massimo) mentre le altre tracce e gli effetti hanno picchi
// più alti della propria media, quindi a parità di media la BGM risultava più forte di 2-3 dB.
//
// Le misure si ottengono con:  python scripts/measure-loudness.py   (serve ffmpeg nel PATH)
// Se si modifica o si aggiunge un file va rimisurato e la tabella aggiornata. Le chiavi sono i nomi con cui
// il suono viene riprodotto (primo argomento di playFx / playBgm).

// Più basso = tutto più piano. Nessun file viene amplificato: oltre -14.3 il file più sensibile ('wrong')
// dovrebbe essere alzato e i picchi di quasi tutti i file superano già 0 dBFS (andrebbero in clip).
export const LOUDNESS_TARGET_LUFS = -16.4;

// Loudness momentanea massima (LUFS-M) di ogni file, prima di qualsiasi guadagno
const MEASURED_PEAK_LUFS = {
    bgm: -13.7,                 // bgm_loop.mp3
    cutscene_intro: -9.2,       // Intro.mp3
    cutscene_inbetween: -6.1,   // inBetween.mp3
    showScore: -8.3,            // showScore_1.mp3
    showScore_last: -8.0,       // showScore_last.mp3
    correct: -7.8,
    double_up: -12.7,
    new_word: -13.3,
    ready: -8.5,
    time_out: -11.1,
    wrong: -14.3,
};

/** Guadagno lineare (<= 1) da applicare al suono per portarlo al livello comune */
export function trimGainFor(name) {
    const measured = MEASURED_PEAK_LUFS[name];
    if (typeof measured !== 'number') return 1;
    return Math.min(1, Math.pow(10, (LOUDNESS_TARGET_LUFS - measured) / 20));
}
